import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Section, SectionNumberingProvider, TemplateDocument, TemplateFooter, TemplateLetterhead, } from '../../../atoms/index.js';
import { BEKRAFTELSE_TEXT, PersonuppgiftSharedBody, SHARED_SAMPLE_VALUES, SHARED_SECTION_DEFS, buildSharedFields, } from '../shared.js';
export const metadata = {
    sections: [
        ...SHARED_SECTION_DEFS,
        { ref: 'bekraftelse', title: 'Bekräftelse' },
    ],
    templateKey: 'personuppgiftsbilaga',
    version: 'v1',
    category: 'Övriga avtal',
    title: 'Personuppgiftsbilaga till hyresavtal · Version 2026',
    shortTitle: 'Personuppgiftsbilaga',
    formNumber: 'Formulär R-16',
    preamble: 'Information om hyresvärdens behandling av hyresgästens personuppgifter.',
    description: 'GDPR-information (artikel 13) om hur hyresvärden behandlar hyresgästens ' +
        'personuppgifter. Rekommenderad bilaga till bostads-, student- och ' +
        'lokalhyresavtal.\n\n' +
        'Skapas som bilaga under ett hyresavtal — visas inte i avtalslistan, har ' +
        'ingen egen signering. Hyresvärdens uppgifter hämtas från avtalet. ' +
        'Bifogas det signerade avtalet automatiskt vid utskick via Scrive.\n\n' +
        'Behöver dokumentet signeras separat (utan ett kopplat hyresavtal) — ' +
        'använd den fristående mallen "Personuppgiftsavtal" under Övriga avtal.',
    status: 'active',
    attachableTo: ['bostadshyra', 'studentbostad', 'lokalhyra'],
    singletonPerParent: true,
    partySlots: [],
};
export const variableSchema = buildSharedFields('bilaga');
export const sampleValues = SHARED_SAMPLE_VALUES;
export function Letterhead() {
    return (_jsx(TemplateLetterhead, { title: metadata.title, formNumber: metadata.formNumber }));
}
export function PageFooter() {
    return _jsx(TemplateFooter, { formNumber: metadata.formNumber });
}
export function Body(props) {
    const { values, mode } = props;
    return (_jsxs(SectionNumberingProvider, { sections: metadata.sections ?? [], values: values, mode: mode, children: [_jsx("p", { className: "mb-4 italic text-stone-600", children: metadata.preamble }), _jsx(PersonuppgiftSharedBody, { ...props }), _jsxs(Section, { sectionRef: "bekraftelse", title: "Bekr\u00E4ftelse", children: [_jsx("p", { className: "text-[10.5px] leading-relaxed text-stone-700", children: BEKRAFTELSE_TEXT }), _jsx("p", { className: "mt-4 text-[10px] italic leading-relaxed text-stone-600", children: "Denna personuppgiftsbilaga utg\u00F6r en del av hyresavtalet och undertecknas elektroniskt tillsammans med det. Egen underskrift kr\u00E4vs inte p\u00E5 denna handling." })] })] }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, {}), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map